<template>
  <div>
    <b-table
        ref="table"
        :id="id"
        :sort-by.sync="sortByProxy"
        :sort-desc.sync=sortDescProxy
        :per-page="perPageProxy"
        :striped="striped"
        :bordered="bordered"
        :borderless="borderless"
        :outlined="outlined"
        :small="small"
        :hover="hover"
        :dark="dark"
        :fixed="fixed"
        :foot-clone="footClone"
        :no-border-collapse="noBorderCollapse"
        :items="items"
        :fields="fields"
        :head-variant="headVariant"
        :table-variant="tableVariant"
        :responsive="responsive"
        show-empty
        :busy="isBusy"
        :no-local-sorting="noLocalSorting"
        @row-clicked="onRowClicked"
    >
      <template #row-details="data">
        <b-tr>
          <b-th colspan="2"><span class="sr-only">Name and ID</span></b-th>

        </b-tr>
      </template>

      <template #empty="scope">
        <div v-if="!paginate"></div>
        <div class="text-center text-dark font-size-base py-4" v-if="paginate || items.length === 0">
          {{ $t("general.no_records_found") }}
        </div>
      </template>
      <template #emptyfiltered="scope">
        <div class="text-center text-dark font-size-base py-4" >{{ $t("general.no_records_found_filter") }}</div>
      </template>
      <template #cell(image)="data">
        <div class="relative" style="max-width: 75px; max-height: 75px;">
          <img :src="data.item.image" class="img-thumbnail mx-auto d-block object-fill" style="max-height: 75px;"/>
          <span v-if="Number(data.item.is_completed) !== 1" class="absolute bg-danger label label-rounded label-danger rounded-lg" style="top: -5px; right: -10px; ">!</span>
        </div>
      </template>

      <template #cell(color)="data">
         <div class="relative" style="max-width: 75px; max-height: 75px;" :style="'background:' + data.item.color">
           <span :style="'color:' + data.item.color">-</span>
         </div>
      </template>

      <template #cell(waybill_action_type)="data">
        <span v-if="Number(data.item.waybill_action_type) === 0"
              v-html="getIconByKey('icons.waybill.exit', {
                  class: 'w-30px h-30px d-inline-block object-fill cursor-pointer'
                })" >
                </span>
        <span v-else
              v-html="getIconByKey('icons.waybill.entry', {
                  class: 'w-30px h-30px d-inline-block object-fill cursor-pointer'
                })" >
                </span>
      </template>
      <template #cell(model_house_action_type)="data">
        <span v-if="Number(data.item.model_house_action_type) === 0"
              v-html="getIconByKey('icons.waybill.exit', {
                  class: 'w-30px h-30px d-inline-block object-fill cursor-pointer'
                })" >
                </span>
        <span v-else
              v-html="getIconByKey('icons.waybill.entry', {
                  class: 'w-30px h-30px d-inline-block object-fill cursor-pointer'
                })" >
                </span>
      </template>
      <template #cell(model_house_status)="data">
        <span class="text-lg" :class="{
          'text-warning': Number(data.item.model_house_status) === 7,
          'text-navy-blue': Number(data.item.model_house_status) === 8,
          'text-navy-blue': Number(data.item.model_house_status) === 9,
          'text-primary': Number(data.item.model_house_status) === 10,
        }">
          {{ data.item.model_house_status_detail.name.toUpperCase() }}
        </span>
      </template>

      <template #cell(status)="data">
        <span class="badge" :class="getStatusClass(data.item.status_id)">{{ data.item.status }}</span>
      </template>
      <template #cell(esc_number)="data">
        <span class="d-block text-center">{{ data.item.esc_number }}</span>
        <span class="d-block text-center text-primary font-weight-bold" v-if="data.item.copied_id">{{ $t('esc.repeated').toUpperCase() }}</span>
      </template>
      <template #cell(model_number)="data">
        <span class="d-block text-center">{{ data.item.model_number }}</span>
        <span class="d-block text-center text-primary font-weight-bold" v-if="Number(data.item.copied_count) > 0">{{ $t('esc.repeated').toUpperCase() }}</span>
      </template>


      <template #cell(actions)="data">
        <template v-if="!('actions' in data.item)">
          <a href="#" @click.prevent="onClickEdit(data.item.id)"><i class="bx bx-edit-alt mr-2"></i> </a>
          <a href="#" @click.prevent="onClickDelete(data.item.id)"><i class="bx bx-trash-alt text-danger ml-2"></i> </a>
        </template>
        <template v-else>
          <button type="button" class="btn btn-xs btn-outline-primary btn-pill" @click="onClickShow(data.item.id)" v-if="data.item.actions && data.item.actions.show"><i class="fas fa-eye font-size-sm"></i> </button>
          <button type="button" class="btn btn-xs btn-outline-primary btn-pill" @click="onClickEdit(data.item.id)" v-if="data.item.actions && data.item.actions.edit"><i class="bx bx-edit-alt font-size-sm"></i> </button>
          <button type="button" class="btn btn-xs btn-outline-danger ml-3 bill-pill" @click="onClickDelete(data.item.id)" v-if="data.item.actions && data.item.actions.delete"><i class="far fa-trash-alt"></i> </button>
        </template>
      </template>

      <template #cell(actionView)="data">
        <button type="button" class="btn btn-xs btn-outline-primary btn-pill" @click="onClickEdit(data.item.id)"><i class="fas fa-eyw font-size-sm"></i> {{ $t('general.show')}}</button>
      </template>

    </b-table>
    <infinite-loading @infinite="onHitBottom">
      <span slot="spinner"></span>
      <span slot="no-more">
        <h4>{{ $t('general.no_more_records')}}</h4>
      </span>
      <span slot="no-results">
          <h4>{{ $t('general.no_records_found')}}</h4>
      </span>
    </infinite-loading>
    <div class="w-100 px-2 mb-10">
      <Pagination v-if="paginate" :paginate="paginate" :page.sync="pageProxy" :perPage.sync="perPageProxy"></Pagination>
    </div>

  </div>
</template>

<script>

import Pagination from "@/assets/components/dataTable/Pagination";

export default {
  name: "dataTable",
  props: {
    id: {
      default: "my-table",
      required: false
    },
    fields: {
      default: [],
      type: Array,
      required: true
    },
    items: {
      default: [],
      type: Array,
      required: true
    },
    title: {
      default: null,
      type: String
    },
    paginate: null,
    striped: {
      type: Boolean,
      default: false
    },
    sortBy: {
      type: String
    },
    sortDesc: {
      type: String
    },
    bordered: {
      type: Boolean,
      default: true
    },
    borderless: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    hover: {
      type: Boolean,
      default: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    footClone: {
      type: Boolean,
      default: false
    },
    headVariant: {
      type: String,
      default: 'none'
    },
    tableVariant: {
      type: String,
      default: 'light'
    },
    noBorderCollapse: {
      type: Boolean,
      default: false
    },
    page: {
      default: 1,
      required: false
    },
    perPage: {
      default: 10,
      required: false,
    },
    responsive: {
      required: false,
      default: true,
    },
    isBusy: {
      required: false,
      default: false,
    },
    noLocalSorting: {
      required: false,
      default: true,
    }
  },
  components: {Pagination},
  data() {
    return {}
  },
  computed: {
    perPageProxy: {
      set(value) {
        this.$emit('update:perPage', value)
      },
      get() {
        return this.perPage;
      },
    },
    pageProxy: {
      set(value) {
        this.$emit('update:page', value)
      },
      get() {
        return this.page;
      },
    },
    sortByProxy: {
      get() {
        return this.sortBy;
      },
      set(value) {
        this.$emit('update:sortBy', value);
      }
    },
    sortDescProxy: {
      get() {
        if (this.sortDesc === "desc") {
          return true;
        }
        return false;
      },
      set(value) {
        if (value) {
          this.$emit('update:sortDesc', "desc");
        } else {
          this.$emit('update:sortDesc', "asc");
        }
      }
    },
  },
  methods: {
    getStatusClass(status) {
      let classes = ['badge-success', 'badge-primary', 'badge-warning', 'badge-info', 'badge-light', 'badge-dark']
      return classes[status]
    },
    onRowClicked(item, index, event){
      this.$emit('row-clicked', item, index, event);
    },
    onClickDelete(id){
      this.$emit('onClickDelete', id);
    },
    onClickEdit(id){
      this.$emit('onClickEdit', id);
    },
    onClickShow(id){
      this.$emit('onClickShow', id);
    },
    onHitBottom($state) {
      this.$emit('hitBottom', $state)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/sass/components/_variables.demo.scss';

  *:focus{
    outline: none;
  }
  .table-light, .table-light > th, .table-light > td {
    background-color: #fff !important;
  }

.table th,
.table td {
  padding: 0.6rem 0.75rem;
  vertical-align: top;
  border-top: 1px solid #DFE3E7;
}
</style>
